import { useEffect } from 'react';
import { useSearchContext } from '@/context/search';

export default () => {
  const [, { setPopstate }] = useSearchContext();
  useEffect(() => {
    // Event handler for history change
    window.onpopstate = e => {
      setPopstate(e.state);
    };
    return () => {
      window.onpopstate = null;
    };
  }, []);
};
